// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
// Module
exports.push([module.id, ".header[data-v-069c752b]{width:100%;height:4.4rem;background:#123465;position:fixed;z-index:1;display:flex;padding:1rem 0;cursor:pointer}.header__item[data-v-069c752b]{width:50%;line-height:2.4rem;font-size:1.6rem;text-align:center}.header__item[data-v-069c752b]:first-child{border-right:0.1rem solid #fff}.header__item-text[data-v-069c752b]{color:#fff}.header__item-text.-active[data-v-069c752b]{line-height:2rem;padding-bottom:0.2rem;border-bottom:0.2rem solid #fff}\n", ""]);
// Exports
module.exports = exports;
